// Textos de Exames (27/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.exames.kpi.sugeridas': 'A confirmar pelo nome',
    'dp.exames.titulo': 'Exames',
    'dp.exames.mes': 'Mês',
    'dp.exames.todosOsMeses': 'Todos os meses',
    'dp.exames.nova': 'Nova convocação',
    'dp.exames.novaTitulo': 'Nova convocação de {{mes}}',
    'dp.exames.situacao.pendente': 'Pendente',
    'dp.exames.situacao.agendado': 'Agendado',
    'dp.exames.situacao.realizado': 'Realizado',
    'dp.exames.situacao.nao_compareceu': 'Não compareceu',
    'dp.exames.situacao.reagendar': 'Reagendar',
    'dp.exames.situacao.cancelado': 'Cancelado',
    'dp.exames.kpi.vencidos': 'Prazo vencido',
    'dp.exames.kpi.proximos': 'Vencem em {{exameDias}} dias',
    'dp.exames.kpi.hoje': 'Agendados para hoje',
    'dp.exames.kpi.pendentes': 'Pendentes',
    'dp.exames.kpi.realizados': 'Realizados',
    'dp.exames.kpi.semPessoa': 'Sem pessoa',
    'dp.exames.col.unidade': 'Unidade',
    'dp.exames.col.exames': 'Exames a realizar',
    'dp.exames.prazoMaximo': 'Prazo máximo',
    'dp.exames.agendadoPara': 'Data agendada',
    'dp.exames.agendadoHoje': 'Agendado para hoje',
    'dp.exames.agendadoEm': 'Agendado para {{data}}',
    'dp.exames.marcadoEm': 'em {{data}}',
    'dp.exames.registrar': 'Registrar',
    'dp.exames.pessoa': 'Quem é a pessoa',
    'dp.exames.sugeridaPeloNome': 'Sugerida pelo nome',
    'dp.exames.sugeridasAviso': '{{n}} convocações têm a pessoa sugerida pelo nome, porque a planilha não traz matrícula. Confirme pelo botão da pessoa.',
    'dp.exames.editarTitulo': 'Exames de {{nome}}',
    'dp.exames.examesUmPorLinha': 'Exames, um por linha',
    'dp.exames.pessoaTitulo': 'Quem é {{nome}}',
    'dp.exames.pessoaConfirmada': 'Matrícula {{m}}, confirmada pelo DP.',
    'dp.exames.pessoaSugerida': 'O Hub sugere a matrícula {{m}}, pelo nome dentro da filial.',
    'dp.exames.pessoaSem': 'Ninguém com este nome na filial. Aponte a matrícula, ou deixe só com o nome.',
    'dp.exames.outraMatricula': 'Matrícula em {{filial}}',
    'dp.exames.desfazer': 'Deixar só o nome',
    'dp.exames.apontar': 'Usar esta matrícula',
    'dp.exames.confirmar': 'Confirmar a sugestão',
    'dp.exames.matriculaOpcional': 'Matrícula, quando houver',
    'dp.exames.nomeSemMatricula': 'Nome, sem matrícula',
    'dp.exames.importarTitulo': 'Importar o controle de exames',
    'dp.exames.importarExplica': 'O controle de exames ocupacionais do DP, uma aba por mês. A pessoa é sugerida pelo nome dentro da unidade, e convocação que o DP já mexeu no Hub não é sobrescrita.',
    'dp.exames.carga.casadas': 'Pessoa sugerida pelo nome',
    'dp.exames.carga.semPessoa': 'Sem pessoa',
    'dp.exames.carga.juntadas': 'Linhas repetidas juntadas',
  },
  en: {
    'dp.exames.kpi.sugeridas': 'To confirm by name',
    'dp.exames.titulo': 'Medical exams',
    'dp.exames.mes': 'Month',
    'dp.exames.todosOsMeses': 'All months',
    'dp.exames.nova': 'New exam call',
    'dp.exames.novaTitulo': 'New exam call for {{mes}}',
    'dp.exames.situacao.pendente': 'Pending',
    'dp.exames.situacao.agendado': 'Scheduled',
    'dp.exames.situacao.realizado': 'Done',
    'dp.exames.situacao.nao_compareceu': 'No show',
    'dp.exames.situacao.reagendar': 'Reschedule',
    'dp.exames.situacao.cancelado': 'Canceled',
    'dp.exames.kpi.vencidos': 'Overdue',
    'dp.exames.kpi.proximos': 'Due within {{exameDias}} days',
    'dp.exames.kpi.hoje': 'Scheduled today',
    'dp.exames.kpi.pendentes': 'Pending',
    'dp.exames.kpi.realizados': 'Done',
    'dp.exames.kpi.semPessoa': 'No person',
    'dp.exames.col.unidade': 'Branch',
    'dp.exames.col.exames': 'Exams to take',
    'dp.exames.prazoMaximo': 'Deadline',
    'dp.exames.agendadoPara': 'Scheduled date',
    'dp.exames.agendadoHoje': 'Scheduled for today',
    'dp.exames.agendadoEm': 'Scheduled for {{data}}',
    'dp.exames.marcadoEm': 'on {{data}}',
    'dp.exames.registrar': 'Record',
    'dp.exames.pessoa': 'Who is the person',
    'dp.exames.sugeridaPeloNome': 'Suggested by name',
    'dp.exames.sugeridasAviso': '{{n}} exam calls have the person suggested by name, since the spreadsheet has no employee ID. Confirm through the person button.',
    'dp.exames.editarTitulo': 'Exams of {{nome}}',
    'dp.exames.examesUmPorLinha': 'Exams, one per line',
    'dp.exames.pessoaTitulo': 'Who is {{nome}}',
    'dp.exames.pessoaConfirmada': 'Employee ID {{m}}, confirmed by HR.',
    'dp.exames.pessoaSugerida': 'The Hub suggests employee ID {{m}}, by name within the branch.',
    'dp.exames.pessoaSem': 'Nobody with this name in the branch. Point the employee ID, or keep just the name.',
    'dp.exames.outraMatricula': 'Employee ID in {{filial}}',
    'dp.exames.desfazer': 'Keep just the name',
    'dp.exames.apontar': 'Use this employee ID',
    'dp.exames.confirmar': 'Confirm the suggestion',
    'dp.exames.matriculaOpcional': 'Employee ID, when there is one',
    'dp.exames.nomeSemMatricula': 'Name, without employee ID',
    'dp.exames.importarTitulo': 'Import the exam control',
    'dp.exames.importarExplica': 'The HR occupational exam control, one sheet per month. The person is suggested by name within the branch, and an exam call HR already changed in the Hub is not overwritten.',
    'dp.exames.carga.casadas': 'Person suggested by name',
    'dp.exames.carga.semPessoa': 'No person',
    'dp.exames.carga.juntadas': 'Repeated rows merged',
  },
  es: {
    'dp.exames.kpi.sugeridas': 'A confirmar por el nombre',
    'dp.exames.titulo': 'Exámenes',
    'dp.exames.mes': 'Mes',
    'dp.exames.todosOsMeses': 'Todos los meses',
    'dp.exames.nova': 'Nueva convocatoria',
    'dp.exames.novaTitulo': 'Nueva convocatoria de {{mes}}',
    'dp.exames.situacao.pendente': 'Pendiente',
    'dp.exames.situacao.agendado': 'Agendado',
    'dp.exames.situacao.realizado': 'Realizado',
    'dp.exames.situacao.nao_compareceu': 'No asistió',
    'dp.exames.situacao.reagendar': 'Reagendar',
    'dp.exames.situacao.cancelado': 'Cancelado',
    'dp.exames.kpi.vencidos': 'Plazo vencido',
    'dp.exames.kpi.proximos': 'Vencen en {{exameDias}} días',
    'dp.exames.kpi.hoje': 'Agendados para hoy',
    'dp.exames.kpi.pendentes': 'Pendientes',
    'dp.exames.kpi.realizados': 'Realizados',
    'dp.exames.kpi.semPessoa': 'Sin persona',
    'dp.exames.col.unidade': 'Unidad',
    'dp.exames.col.exames': 'Exámenes a realizar',
    'dp.exames.prazoMaximo': 'Plazo máximo',
    'dp.exames.agendadoPara': 'Fecha agendada',
    'dp.exames.agendadoHoje': 'Agendado para hoy',
    'dp.exames.agendadoEm': 'Agendado para {{data}}',
    'dp.exames.marcadoEm': 'el {{data}}',
    'dp.exames.registrar': 'Registrar',
    'dp.exames.pessoa': 'Quién es la persona',
    'dp.exames.sugeridaPeloNome': 'Sugerida por el nombre',
    'dp.exames.sugeridasAviso': '{{n}} convocatorias tienen la persona sugerida por el nombre, porque la planilla no trae matrícula. Confirme con el botón de la persona.',
    'dp.exames.editarTitulo': 'Exámenes de {{nome}}',
    'dp.exames.examesUmPorLinha': 'Exámenes, uno por línea',
    'dp.exames.pessoaTitulo': 'Quién es {{nome}}',
    'dp.exames.pessoaConfirmada': 'Matrícula {{m}}, confirmada por el DP.',
    'dp.exames.pessoaSugerida': 'El Hub sugiere la matrícula {{m}}, por el nombre dentro de la filial.',
    'dp.exames.pessoaSem': 'Nadie con este nombre en la filial. Indique la matrícula, o déjelo solo con el nombre.',
    'dp.exames.outraMatricula': 'Matrícula en {{filial}}',
    'dp.exames.desfazer': 'Dejar solo el nombre',
    'dp.exames.apontar': 'Usar esta matrícula',
    'dp.exames.confirmar': 'Confirmar la sugerencia',
    'dp.exames.matriculaOpcional': 'Matrícula, cuando haya',
    'dp.exames.nomeSemMatricula': 'Nombre, sin matrícula',
    'dp.exames.importarTitulo': 'Importar el control de exámenes',
    'dp.exames.importarExplica': 'El control de exámenes ocupacionales del DP, una hoja por mes. La persona se sugiere por el nombre dentro de la unidad, y la convocatoria que el DP ya cambió en el Hub no se sobrescribe.',
    'dp.exames.carga.casadas': 'Persona sugerida por el nombre',
    'dp.exames.carga.semPessoa': 'Sin persona',
    'dp.exames.carga.juntadas': 'Filas repetidas juntadas',
  },
}
